// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions, handleActions } from 'redux-actions';

export const {
    setHiddenAnnouncement,
} = createActions(
    'SET_HIDDEN_ANNOUNCEMENT'
);

export const INITIAL_STATE: {
    message?: string;
} = { message: '' };

export type HiddenAnnouncementStoreType = Readonly<typeof INITIAL_STATE>;

export default handleActions(
    {
        [setHiddenAnnouncement.toString()]: _setHiddenAnnouncement,
    },
    INITIAL_STATE
);

function _setHiddenAnnouncement(
    state: any,
    { payload }: { payload: HiddenAnnouncementStoreType }
): HiddenAnnouncementStoreType {
    if (payload) {
        return {
            ...state,
            ...payload,
        };
    }

    return state;
}
